import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function AdminPage() {
    const navigate = useNavigate();

    useEffect(() => {
        // 로그인 상태 체크
        const token = localStorage.getItem("adminToken");
        
        if (token) {
            // 로그인 됨 → notices 페이지로
            navigate("/admin/notices");
        } else {
            // 로그인 안됨 → login 페이지로
            navigate("/admin/login");
        }
    }, [navigate]);

    // 로딩 중 표시
    return (
        <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100vh',
            fontSize: '18px',
            color: '#666'
        }}>
            로딩 중...
        </div>
    );
}

